import { gql } from '@apollo/client/core';

/**
 * Deliberately mirrors `App/Event/fragments.ts`'s `EVENT_LIST_MINIMAL_FIELDS` field-for-field —
 * those two must stay in sync. It is declared `on Event` because the `createHolds` payload
 * returns `EventGroup.events: [Event!]!`, whereas the events *list* returns `EventSummary`.
 * Like its twin it omits `ticketTotals`, `description`, `footerContent`, `minimumAge` and
 * `ticketsUrl`: these rows feed the calendar, which never reads them, and selecting them would
 * add backend cost for nothing.
 */
export const HOLD_EVENT_FIELDS = gql`
  fragment HoldEventFields on Event {
    id
    name
    slug
    date
    startTime
    doorTime
    endTime
    timezone
    state
    ticketed
    holdPreference
    venue {
      id
      name
    }
    venueRoom {
      id
      name
      venue {
        id
        name
      }
    }
    eventGroup {
      id
      name
    }
    seatingChart {
      id
      name
    }
    announceDetail {
      announceAt
    }
  }
`;

export const HOLD_EVENT_GROUP_FIELDS = gql`
  fragment HoldEventGroupFields on EventGroup {
    id
    name
    events {
      ...HoldEventFields
    }
  }
  ${HOLD_EVENT_FIELDS}
`;
